






















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import MessageSendGruopPO from "@/store/entities/messageinfo/messagesendgrouppo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Moment from "moment";
import Util from "@/lib/util";

@Component({
    components: { TreeSelect },
})
export default class EditMessageSendGroup extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    entity: MessageSendGruopPO = new MessageSendGruopPO();
    loading: boolean = false;
    targetKeys: any[] = [];
    devicelist: any[] = [];//设备列表
    async created() {
        await this.getOrganizations();
        this.getItemDetail();
        //await this.getUserList();
    }
    handleChange(newTargetKeys) {
        this.targetKeys = newTargetKeys;
    }
    //获取设备
    async getMeter() {
        this.devicelist = [];
        if (this.entity.meterType != undefined) {
            await this.$store
                .dispatch({ type: "messagesendgroup/getDeviceList", data: this.entity.meterType })
                .then((val) => {
                    if (val.length > 0) {
                        //console.log(val);
                        val.forEach((ele) => {
                            this.devicelist.push({ key: ele.id, label: ele.deviceNo + '>>' + ele.roomNo, description: ele.location });
                        });
                        this.targetKeys = this.entity.deviceList;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }
    //获取明细
    getItemDetail() {
        if (localStorage.getItem("itemdetail") === null) {
            this.$store.dispatch({
                type: "itemdetail/getdetailtolocalstorge",
            });
        }
        let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
        if (detaillist.length > 0) {
            let info = detaillist.filter((p) => {
                return p.itemId == 7 && p.id != 133;
            });
            info.forEach((ele) => {
                this.$data.meterType.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
        }
    }
    //获取组织
    async getOrganizations() {
        await this.$store
            .dispatch("organization/getCommanySelectTree")
            .then((val) => {
                this.$data.organizations = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    //获取所有表计

    //保存
    save() {
        (this.$refs.itemForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.entity.deviceList = [];
                this.entity.deviceList = this.targetKeys;
                console.log(this.entity);
                this.loading = true;
                await this.$store
                    .dispatch({
                        type: "messagesendgroup/update",
                        data: this.entity,
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
                this.loading = false;
                this.devicelist = [];
                this.targetKeys = [];
                (this.$refs.itemForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.itemForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.entity = Util.extend(true, {}, this.$store.state.messagesendgroup.messageSendGroupItems);
            this.getMeter();
        }
    }
    itemRule = {
        organizationId: [
            {
                required: true,
                type: "number",
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        sendType: [
            {
                required: true,
                type: "number",
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        name: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        meterType: [
            {
                required: true,
                type: "number",
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            }
        ],
        targetUser: [{
            required: true,
            message: this.L("CanNotBeEmpty"),
            trigger: "blur",
        }],
    };

    data() {
        return {
            organizations: [], //组织
            meterType: [], //表计类型
            listStyle: {
                width: "40%",
            },
            render(item) {
                return item.label + " - " + item.description;
            },
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                    isDisabled: node.type == 1 ? true : false,
                };
            },
        };
    }
}
